/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PermittedOutletDTO = {
  address?: string;
  /** Returned when the outlets are asked for with balances=true. */
  availableBalance?: number;
  /** Returned when the outlets are asked for with balances=true. */
  balance?: number;
  id?: string;
  isCurrent?: boolean;
  isDefault?: boolean;
  /** Returned when the outlets are asked for with balances=true. */
  ledgerBalance?: number;
  location?: string;
  name?: string;
  /**
   * The image the merchant uploaded for this outlet, as a data URL. The
   * permitted-outlets endpoint does not return it, so the outlet load reads it
   * from GET /api/v1/outlets. Not in the generated client yet.
   */
  outletImage?: string;
  role?: string;
  status?: PermittedOutletDTO.status;
  walletId?: string;
};

export namespace PermittedOutletDTO {
  export enum status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
  }
}
